import type { Route } from "./+types/signup-route";
import SignUp from "./components/Signup";
import { generateSeoMeta } from "~/common/utils/seo-meta";

export function meta({}: Route.MetaArgs) {
  return generateSeoMeta({
    title: "Реєстрація",
    description:
      "Створіть обліковий запис Brandly для контролю торгових марок. Відстежуйте заявки, отримуйте нагадування про дедлайни в Telegram.",
    noindex: true,
  });
}

export default function SignupRoute() {
  return <SignUp />;
}
